import styled from "styled-components";
import { TeamCard } from "../TeamCard";

export const StyledTeamsSection = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => props.theme.spacing(4)};

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    margin-top: ${(props) => props.theme.spacing(8)};
  }
`;

export const StyledHeading = styled.h2`
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.25px;
  line-height: 20px;
  margin-bottom: ${(props) => props.theme.spacing(6)};

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    margin-bottom: ${(props) => props.theme.spacing(9)};
  }
`;

export const StyledTeamGroupingSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) => props.theme.spacing(10)};
`;

export const StyledSubHeading = styled.h2`
  border-bottom: 1px solid ${(props) => props.theme.colors.borderPrimary};
  color: ${(props) => props.theme.colors.textDarker};
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.25px;
  line-height: 20px;
  padding-bottom: ${(props) => props.theme.spacing(4)};
`;

export const StyledTeamsGrid = styled.ul`
  display: grid;
  gap: ${(props) => props.theme.spacing(4, 8)};
  grid-template-columns: repeat(1, 1fr);
  height: auto;
  padding-top: ${(props) => props.theme.spacing(4)};
  width: 100%;

  @media ${({ theme: { media } }) => media.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${({ theme: { media } }) => media.desktop} {
    grid-template-columns: repeat(3, 1fr);
  }

  & li {
    height: auto;
    min-width: 0;
    width: auto;
  }
`;

export const StyledTeamCardWithHover = styled(TeamCard)`
  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    &:hover {
      background-color: #edeff0;
    }
  }
`;
